module.exports = __webpack_public_path__ + "video_icon.76d79366.png";